module.exports = __webpack_public_path__ + "media/img/pages/profile/aldi ger 2-d0a787889959bdab5a63f2d5bf537c07.jpg";